import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
  RBAC_TYPE_TEAMS,
  RBAC_TYPE_USERS,
  ROLES_TAB_TYPE_TEAMS,
  ROLES_TAB_TYPE_USERS,
  USER_INVITE,
  USER_VIEW,
} from '../../constants/RoleConsts';
import { validateUserSession } from '../../utils/authUtils';
import { getDefaultRoles } from '../../utils/PropertyAPIUtils';
import UserInvite from './users/user-invite/User-Invite';
import UserView from './users/user-view/User-View';
import UsersList from './users/users-list/Users-List';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../utils/loaderSlice';
import { useDispatch } from 'react-redux';
import { ENVIRONMENT } from '../../env/Configurations';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const UsersAndTeams = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(ROLES_TAB_TYPE_USERS); // TEAMS tab will be added ina future
  const [state, setState] = useState({
    type: USER_INVITE,
    status: false,
    obj: null,
  });
  const [refreshTick, setRefreshTick] = useState(0);
  const [lstRoles, setLstRoles] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    (async () => {
      try {
        dispatch(stepUpLoaderCount());
        if (!lstRoles.length) {
          const result = await getDefaultRoles();
          setLstRoles(result.data.getAllDefaultRoles);
        }
      } catch (error) {
        setLstRoles([]);
        if (ENVIRONMENT === 'dev') {
          console.log(error?.message);
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    })();
  }, [lstRoles]);

  const onSaved = () => {
    setRefreshTick((t) => t + 1);
    setState({ type: USER_INVITE, status: false, obj: null });
  };

  const onToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case USER_INVITE:
        return (
          <UserInvite
            onToggle={onToggle}
            user={state.obj}
            lstRoles={lstRoles}
            showLoader={showLoader}
          />
        );
      case USER_VIEW:
        return <UserView onToggle={onToggle} user={state.obj} permissions={permissions} />;
      default:
        break;
    }
  };

  return (
    <>
      <div className='container pt-4' style={{ display: state.status ? 'none' : 'block' }}>
        <div className='row d-flex'>
          <div className='col-md-6'>
            <span className='page-title'>Users & Teams</span>
          </div>
        </div>
        <div className='row d-flex pt-4'>
          <div>
            {permissions[RBAC_TYPE_USERS] > RBAC_PERMISSION_LEVEL_NO_ACCESS && (
              <Button
                size='large'
                variant={activeTab === ROLES_TAB_TYPE_USERS ? 'outlined' : 'text'}
                className={
                  activeTab === ROLES_TAB_TYPE_USERS ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(ROLES_TAB_TYPE_USERS)}
              >
                Users
              </Button>
            )}
            {permissions[RBAC_TYPE_TEAMS] > RBAC_PERMISSION_LEVEL_NO_ACCESS && false && (
              <Button
                size='large'
                variant={activeTab === ROLES_TAB_TYPE_TEAMS ? 'outlined' : 'text'}
                className={
                  activeTab === ROLES_TAB_TYPE_TEAMS ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(ROLES_TAB_TYPE_TEAMS)}
              >
                TEAMS
              </Button>
            )}
          </div>
        </div>
        <div className='row p-2 d-flex pt-4'>
          <div className='card shadow'>
            {activeTab === ROLES_TAB_TYPE_USERS && (
              <UsersList
                onToggle={onToggle}
                permissions={permissions}
                lstRoles={lstRoles}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
                refreshTick={refreshTick}
              />
            )}
          </div>
        </div>
      </div>
      {state.status && (
        <>
          {state.type === USER_INVITE && (
            <UserInvite
              onToggle={onToggle}
              user={state.obj}
              lstRoles={lstRoles}
              showLoader={showLoader}
              onSaved={onSaved}
            />
          )}
          {state.type === USER_VIEW && (
            <UserView onToggle={onToggle} user={state.obj} permissions={permissions} />
          )}
        </>
      )}
    </>
  );
};

export default UsersAndTeams;
